/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_New_BtnInputs */



/**
* | output |
* | --- |
* | "New Tournament" |
*
* @param {Tournaments_New_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_new_btn = /** @type {((inputs?: Tournaments_New_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_New_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Novo Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo Torneo")
	return /** @type {LocalizedString} */ ("New Tournament")
});